import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { parseJSONfromText } from "../../author/hooks/useImportPlans"; // Adjust the import path as necessary
import Dialog from "../../../common/Dialog";
import Loading from "../../Loading";
import { firestore } from "../../../../database/firebase";
import DB_PATH from "../../../../database/DB_PATH";
import Checkbox from "../../../common/Checkbox";
import TextInputForVision from "../../plan/components/TextInputForVision";
import { Quote } from "../../../../types/Quote";

const ImportQuotes = ({ communityId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState<Quote[]>([]);
  const [isJSONImport, setIsJSONImport] = useState(false);

  const parseDataToQuotes = (inputData: any[]): Quote[] => {
    if (!inputData || !Array.isArray(inputData)) {
      console.log("No valid data to parse");
      return [];
    }

    return inputData.map(
      (item): Quote => ({
        stepID: item.stepID || "",
        quote: item.quote || "",
        authorName: item.authorName || "",
        likeCount: item.likeCount || 0,
        source: item.source || "",
        imageURL: item.imageURL || "",
        planID: item.planID || "",
        id: item.id || "",
        createdAt: item.createdAt || new Date().toUTCString(),
        communityId,
      })
    );
  };

  const uploadQuotes = async () => {
    console.log("Uploading Quotes", data);

    if (!data || data.length === 0) return;

    try {
      for (const quote of data) {
        const quoteRef = await firestore.collection(DB_PATH.QUOTE).add(quote);
        const quoteID = quoteRef.id;
        console.log("QuoteAdded", quote);
        // Update the quote document with the generated ID
        await quoteRef.update({ id: quoteID });
      }

      console.log("Quotes uploaded successfully!");
    } catch (error) {
      console.error("Error uploading quotes: ", error);
    }
  };

  const toggleJSONImport = () => {
    setIsJSONImport(!isJSONImport);
  };

  const handleTextToUpload = async (text) => {
    setIsLoading(true);
    console.log("TextToBeUploaded", text);
    let parsedData = parseJSONfromText(text);
    if (Array.isArray(parsedData)) {
      const quotes = parseDataToQuotes(parsedData);
      setData(quotes);
    } else {
      console.error("Invalid data format");
    }
    setIsLoading(false);
    console.log("ParsedQuotes", data);
  };

  return (
    <div>
      <Button
        style={{ marginTop: 8 }}
        color={"primary"}
        variant="outlined"
        onClick={(e) => {
          setShow(true);
        }}
      >
        Import Quotes
      </Button>
      <Dialog
        positiveAction={uploadQuotes}
        negativeAction={() => setShow(false)}
        onCloseDialog={() => setShow(false)}
        positiveText={"Finish"}
        negativeText={"Cancel"}
        description={""}
        title={"Import Quotes"}
        isOpen={show}
        ExtraButton={
          !isLoading ? (
            <div>
              <Checkbox
                checked={isJSONImport}
                onChange={toggleJSONImport}
                label="Import as JSON"
              ></Checkbox>
              <TextInputForVision onTextExtracted={handleTextToUpload} />
            </div>
          ) : (
            <Loading></Loading>
          )
        }
      ></Dialog>
    </div>
  );
};

export default ImportQuotes;
